"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ad_materials_1 = (0, tslib_1.__importDefault)(require("./ad-materials"));
const arrow_down_1 = (0, tslib_1.__importDefault)(require("./arrow-down"));
const arrow_left_1 = (0, tslib_1.__importDefault)(require("./arrow-left"));
const arrow_right_1 = (0, tslib_1.__importDefault)(require("./arrow-right"));
const bell_1 = (0, tslib_1.__importDefault)(require("./bell"));
const bell_badge_1 = (0, tslib_1.__importDefault)(require("./bell-badge"));
const book_events_1 = (0, tslib_1.__importDefault)(require("./book-events"));
const cart_1 = (0, tslib_1.__importDefault)(require("./cart"));
const chevron_left_1 = (0, tslib_1.__importDefault)(require("./chevron-left"));
const chevron_right_1 = (0, tslib_1.__importDefault)(require("./chevron-right"));
const close_1 = (0, tslib_1.__importDefault)(require("./close"));
const close_circular_1 = (0, tslib_1.__importDefault)(require("./close-circular"));
const dotted_arrow_down_1 = (0, tslib_1.__importDefault)(require("./dotted-arrow-down"));
const dotted_arrow_right_1 = (0, tslib_1.__importDefault)(require("./dotted-arrow-right"));
const dotted_arrow_right_2_1 = (0, tslib_1.__importDefault)(require("./dotted-arrow-right-2"));
const exclamation_mark_1 = (0, tslib_1.__importDefault)(require("./exclamation-mark"));
const filter_list_1 = (0, tslib_1.__importDefault)(require("./filter-list"));
const import_icon_1 = (0, tslib_1.__importDefault)(require("./import-icon"));
const export_icon_1 = (0, tslib_1.__importDefault)(require("./export-icon"));
const file_transfer_icon_1 = (0, tslib_1.__importDefault)(require("./file-transfer-icon"));
const pencil_1 = (0, tslib_1.__importDefault)(require("./pencil"));
const pencil_2_1 = (0, tslib_1.__importDefault)(require("./pencil-2"));
const profile_1 = (0, tslib_1.__importDefault)(require("./profile"));
const question_mark_circle_1 = (0, tslib_1.__importDefault)(require("./question-mark-circle"));
const search_1 = (0, tslib_1.__importDefault)(require("./search"));
const shop_merch_1 = (0, tslib_1.__importDefault)(require("./shop-merch"));
const shop_bag_1 = (0, tslib_1.__importDefault)(require("./shop-bag"));
const tools_for_you_1 = (0, tslib_1.__importDefault)(require("./tools-for-you"));
const directv_logo_1 = (0, tslib_1.__importDefault)(require("./directv-logo"));
const person_2_1 = (0, tslib_1.__importDefault)(require("./person-2"));
const person_crop_rectangle_stack_1 = (0, tslib_1.__importDefault)(require("./person-crop-rectangle-stack"));
const books_vertical_1 = (0, tslib_1.__importDefault)(require("./books-vertical"));
const envelope_1 = (0, tslib_1.__importDefault)(require("./envelope"));
const four_plus_rectangle_1 = (0, tslib_1.__importDefault)(require("./four-plus-rectangle"));
const megaphone_1 = (0, tslib_1.__importDefault)(require("./megaphone"));
const homepage_image_1 = (0, tslib_1.__importDefault)(require("./homepage-image"));
const media_tile_1 = (0, tslib_1.__importDefault)(require("./media-tile"));
const calendar_1 = (0, tslib_1.__importDefault)(require("./calendar"));
const pen_1 = (0, tslib_1.__importDefault)(require("./pen"));
const read_circle_1 = (0, tslib_1.__importDefault)(require("./read-circle"));
const Icons = {
    DirectvLogo: directv_logo_1.default,
    DottedArrowDown: dotted_arrow_down_1.default,
    DottedArrowRight: dotted_arrow_right_1.default,
    DottedArrowRight2: dotted_arrow_right_2_1.default,
    CloseCircular: close_circular_1.default,
    Close: close_1.default,
    Profile: profile_1.default,
    Shopbag: shop_bag_1.default,
    AdMaterials: ad_materials_1.default,
    BookEvents: book_events_1.default,
    ShopMerch: shop_merch_1.default,
    ToolsForYou: tools_for_you_1.default,
    ArrowLeft: arrow_left_1.default,
    ArrowRight: arrow_right_1.default,
    ArrowDown: arrow_down_1.default,
    Search: search_1.default,
    Cart: cart_1.default,
    ChevronLeft: chevron_left_1.default,
    ChevronRight: chevron_right_1.default,
    QuestionMarkCircle: question_mark_circle_1.default,
    Bell: bell_1.default,
    BellBadge: bell_badge_1.default,
    ImportIcon: import_icon_1.default,
    ExportIcon: export_icon_1.default,
    FileTransferIcon: file_transfer_icon_1.default,
    FilterList: filter_list_1.default,
    Pencil: pencil_1.default,
    Pencil2: pencil_2_1.default,
    ExclamationMark: exclamation_mark_1.default,
    Person2: person_2_1.default,
    PersonCropRectangleStack: person_crop_rectangle_stack_1.default,
    BooksVertical: books_vertical_1.default,
    Envelope: envelope_1.default,
    FourPlusRectangle: four_plus_rectangle_1.default,
    Megaphone: megaphone_1.default,
    HomepageImage: homepage_image_1.default,
    Calendar: calendar_1.default,
    Pen: pen_1.default,
    ReadCircleIcon: read_circle_1.default,
    MediaTileIcon: media_tile_1.default,
};
exports.default = Icons;
